'use client';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

export default function OptimizelyId() {
  useEffect(() => {
    if (window !== undefined) {
      if (typeof window?.['optimizely']?.get === 'function') {
        const id = window['optimizely'].get('visitor_id');
        if (id?.randomId) {
          Cookies.set('optimizelyUserId', id?.randomId, { expires: 90 });
        }
      }
    }
  }, []);
  return null;
}
